<template>
  <div class="page-wrapper">
    <main class="main mb-10 pb-1">
      <nav class="breadcrumb-nav container">
        <ul class="breadcrumb bb-no">
          <li>
            <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
          </li>
          <li>
            {{ duoyuyan(shangpin) }}
          </li>
        </ul>
      </nav>
      <div class="page-content" v-loading="loading">
        <div class="container">
          <div class="row gutter-lg">
            <div class="main-content">
              <div class="product product-single row">
                <div class="col-md-6 mb-6">
                  <div class="product-gallery product-gallery-sticky">
                    <el-carousel
                      :interval="5000"
                      arrow="always"
                      style="width: 100%"
                    >
                      <el-carousel-item
                        v-for="(item, index) in shangpin.tupian"
                        :key="index"
                      >
                        <figure class="shangpin-image">
                          <el-image
                            :src="item"
                            :preview-src-list="shangpin.tupian"
                          ></el-image>
                        </figure>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
                <div class="col-md-6 mb-4 mb-md-6">
                  <div
                    class="product-details"
                    data-sticky-options="{'minWidth': 767}"
                  >
                    <h1 class="product-title">{{ duoyuyan(shangpin) }}</h1>
                    <div class="product-bm-wrapper">
                      <figure
                        class="brand"
                        v-if="
                          shangpin.fenleis &&
                          shangpin.fenleis.length > 0 &&
                          shangpin.fenleis[0].tupian !== ''
                        "
                      >
                        <img
                          :src="shangpin.fenleis[0].tupian"
                          alt=""
                          width="102"
                          height="48"
                        />
                      </figure>
                      <div class="product-meta">
                        <div class="product-categories">
                          {{ $yuyanbao.fenlei }} :
                          <span class="product-category">
                            <span
                              v-for="(fl, fli) in shangpin.fenleis"
                              :key="fli"
                            >
                              <router-link
                                :to="{
                                  path: '/products',
                                  query: { ukey: fl.ukey },
                                }"
                              >
                                {{ duoyuyan(fl) }}
                              </router-link>
                            </span>
                          </span>
                        </div>
                        <div class="product-sku">
                          {{ $yuyanbao.sku }}: <span>{{ shangpin.ref }}</span>
                        </div>
                      </div>
                    </div>

                    <hr class="product-divider" />
                    <div
                      class="product-price"
                      v-if="shangpin.leixing === 1 || shangpin.leixing === 3"
                    >
                      <ins class="new-price">
                        {{
                          (shangpin.jiage / 100).toFixed(2) + $shezhi.huobi
                        }}</ins
                      >
                    </div>
                    <div class="product-price" v-if="shangpin.leixing === 2">
                      <ins class="new-price">
                        {{ (guige.jiage / 100).toFixed(2) + $shezhi.huobi }}
                      </ins>
                    </div>
                    <div
                      class="product-short-desc"
                      v-html="duoyuyan(shangpin, 'miaoshu')"
                    ></div>
                    <hr class="product-divider" />
                    <div v-if="shangpin.leixing === 2">
                      <el-radio-group v-model="guige">
                        <el-radio
                          style="margin: 0 8px 8px 0"
                          size="small"
                          border
                          v-for="(item, index) in shangpin.sku"
                          :key="index"
                          :label="item"
                          >{{
                            format_guige(item.guige) +
                            " (" +
                            duoyuyan(item, "miaoshu") +
                            ")"
                          }}</el-radio
                        >
                      </el-radio-group>
                    </div>
                    <div v-if="shangpin.leixing === 3">
                      <section
                        class="related-product-section"
                        v-for="(item, index) in shangpin.menu"
                        :key="index"
                      >
                        <div class="mb-4">
                          <h4 class="title">
                            {{ duoyuyan(item) }}
                            <span style="font-size: 14px; padding-left: 6px">{{
                              "(" + item.shuliang + ")"
                            }}</span>
                          </h4>
                        </div>
                        <div class="row cols-4">
                          <div
                            class="product"
                            v-for="(sp, spi) in item.shangpin"
                            :key="spi"
                          >
                            <figure class="product-media">
                              <router-link
                                :to="{
                                  path: '/product',
                                  query: { ukey: sp.ukey },
                                }"
                              >
                                <img
                                  :src="
                                    sp.tupian && sp.tupian.length > 0
                                      ? sp.tupian[0]
                                      : $tupianmoren
                                  "
                                  alt=""
                                  width="300"
                                  height="338"
                                  style="aspect-ratio: 1"
                                />
                              </router-link>
                            </figure>
                            <div class="product-details">
                              <h4 class="product-name">
                                <router-link
                                  :to="{
                                    path: '/product',
                                    query: { ukey: sp.ukey },
                                  }"
                                  >{{ duoyuyan(sp) }}
                                </router-link>
                              </h4>
                            </div>
                          </div>
                        </div>

                        <hr class="product-divider" />
                      </section>
                    </div>
                    <!-- <div class="product-form mt-2">
                      <div class="product-qty-form">
                        <div class="input-group">
                          <input
                            class="quantity form-control"
                            type="number"
                            min="1"
                            max="10000000"
                            v-model="count"
                            @input="
                              count = count > 99 ? 99 : count == 0 ? 1 : count
                            "
                          />
                          <button
                            class="quantity-plus w-icon-plus"
                            @click="count < 99 ? count++ : ''"
                          ></button>
                          <button
                            class="quantity-minus w-icon-minus"
                            @click="count > 1 ? count-- : ''"
                          ></button>
                        </div>
                      </div>
                      <button class="btn btn-primary yxl-btn-cart">
                        <i class="w-icon-cart" style="margin-right: 4px"></i>
                        <span>{{ $yuyanbao.tianjiagouwuche }}</span>
                      </button>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="tab tab-nav-boxed tab-nav-underline product-tabs">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a
                      href="#product-tab-description"
                      class="nav-link active"
                      >{{ $yuyanbao.miaoshu }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a href="#product-tab-specification" class="nav-link">{{
                      $yuyanbao.canshu
                    }}</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="product-tab-description">
                    <div v-html="duoyuyan(shangpin, 'miaoshu')"></div>
                  </div>
                  <div class="tab-pane" id="product-tab-specification">
                    <ul class="list-none">
                      <li v-for="(item, index) in shangpin.canshu" :key="index">
                        <label>{{ duoyuyan(item.canshu) }}</label>
                        <p>{{ duoyuyan(item.canshuzhi) }}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <section
                class="related-product-section"
                v-if="shangpin.xiangsi && shangpin.xiangsi.length > 0"
              >
                <div class="title-link-wrapper mb-4">
                  <h4 class="title">{{ $yuyanbao.xiangsishangpin }}</h4>
                </div>
                <div
                  class="swiper-container swiper-theme"
                  data-swiper-options="{ 'spaceBetween': 20, 'slidesPerView': 2, 'breakpoints': { '576': { 'slidesPerView': 3 }, '768': { 'slidesPerView': 4 }, '992': { 'slidesPerView': 3 }}}"
                >
                  <div
                    class="swiper-wrapper row cols-lg-3 cols-md-4 cols-sm-3 cols-2"
                  >
                    <div
                      class="swiper-slide product"
                      v-for="(item, index) in shangpin.xiangsi"
                      :key="index"
                    >
                      <figure class="product-media">
                        <router-link
                          :to="{ path: '/product', query: { ukey: item.ukey } }"
                        >
                          <img
                            :src="
                              item.tupian.length > 0
                                ? item.tupian[0]
                                : $tupianmoren
                            "
                            alt=""
                            width="300"
                            height="338"
                            style="aspect-ratio: 1"
                          />
                        </router-link>
                        <div class="product-action">
                          <router-link
                            :to="{
                              path: '/product',
                              query: { ukey: item.ukey },
                            }"
                            class="btn-product btn-quickview"
                            >{{ $yuyanbao.xiangqing }}</router-link
                          >
                        </div>
                      </figure>
                      <div class="product-details">
                        <h4 class="product-name">
                          <router-link
                            :to="{
                              path: '/product',
                              query: { ukey: item.ukey },
                            }"
                            >{{ duoyuyan(item) }}
                          </router-link>
                        </h4>
                        <div class="product-pa-wrapper">
                          <div class="product-price">
                            <span
                              v-if="item.leixing === 1 || item.leixing === 3"
                            >
                              {{
                                (item.jiage / 100).toFixed(2) + $shezhi.huobi
                              }}
                            </span>
                            <span v-if="item.leixing === 2">
                              {{
                                (min_jiage(item) / 100).toFixed(2) +
                                $shezhi.huobi
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <aside
              class="sidebar product-sidebar sidebar-fixed right-sidebar sticky-sidebar-wrapper"
            >
              <div class="sidebar-overlay"></div>
              <a class="sidebar-close" href="#"><i class="close-icon"></i></a>
              <a href="#" class="sidebar-toggle d-flex d-lg-none"
                ><i class="fas fa-chevron-left"></i
              ></a>
              <div class="sidebar-content scrollable">
                <div class="sticky-sidebar">
                  <div
                    class="widget widget-icon-box mb-6"
                    v-for="(item, index) in jihe"
                    :key="index"
                  >
                    <div class="icon-box icon-box-side">
                      <span class="icon-box-icon text-dark">
                        <img
                          :src="item.tupian"
                          style="aspect-ratio: 1; width: 34px; height: 34px"
                        />
                      </span>
                      <div class="icon-box-content">
                        <h4 class="icon-box-title">{{ duoyuyan(item) }}</h4>
                        <p v-html="duoyuyan(item, 'miaoshu')"></p>
                      </div>
                    </div>
                  </div>
                  <div class="widget widget-banner mb-9">
                    <div class="banner banner-fixed br-sm">
                      <figure
                        v-if="shangpin.tupian && shangpin.tupian.length > 0"
                      >
                        <img
                          :src="shangpin.tupian[0]"
                          alt="Banner"
                          width="266"
                          height="220"
                          style="background-color: #1d2d44"
                        />
                      </figure>
                    </div>
                  </div>
                  <div class="widget widget-products">
                    <div class="title-link-wrapper mb-4">
                      <h4 class="title title-link font-weight-bold"></h4>
                      <div
                        style="text-align: right; width: 100%"
                        v-if="shangpins.length > 3"
                      >
                        <i
                          class="el-icon el-icon-arrow-left pointer"
                          @click="$refs.shangpinref.prev()"
                        ></i>
                        <i
                          class="el-icon el-icon-arrow-right pointer"
                          @click="$refs.shangpinref.next()"
                        ></i>
                      </div>
                    </div>
                    <el-carousel
                      :interval="5000"
                      arrow="never"
                      style="width: 100%"
                      ref="shangpinref"
                    >
                      <el-carousel-item
                        v-for="i in Math.ceil(shangpins.length / 3)"
                        :key="i"
                      >
                        <div
                          class="product product-widget"
                          v-if="shangpins[(i - 1) * 3]"
                        >
                          <figure class="product-media">
                            <router-link
                              :to="{
                                path: '/product',
                                query: { ukey: shangpins[(i - 1) * 3].ukey },
                              }"
                            >
                              <img
                                :src="
                                  shangpins[(i - 1) * 3].tupian.length > 0
                                    ? shangpins[(i - 1) * 3].tupian[0]
                                    : $tupianmoren
                                "
                                alt=""
                                width="100"
                                height="113"
                              />
                            </router-link>
                          </figure>
                          <div class="product-details">
                            <h4 class="product-name">
                              <router-link
                                :to="{
                                  path: '/product',
                                  query: { ukey: shangpins[(i - 1) * 3].ukey },
                                }"
                              >
                                {{ duoyuyan(shangpins[(i - 1) * 3]) }}
                              </router-link>
                            </h4>
                            <div class="product-price">
                              <span
                                v-if="
                                  shangpins[(i - 1) * 3].leixing === 1 ||
                                  shangpins[(i - 1) * 3].leixing === 3
                                "
                              >
                                {{
                                  (shangpins[(i - 1) * 3].jiage / 100).toFixed(
                                    2
                                  ) + $shezhi.huobi
                                }}
                              </span>
                              <span v-if="shangpins[(i - 1) * 3].leixing === 2">
                                {{
                                  (
                                    min_jiage(shangpins[(i - 1) * 3]) / 100
                                  ).toFixed(2) + $shezhi.huobi
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="product product-widget"
                          v-if="shangpins[(i - 1) * 3 + 1]"
                        >
                          <figure class="product-media">
                            <router-link
                              :to="{
                                path: '/product',
                                query: {
                                  ukey: shangpins[(i - 1) * 3 + 1].ukey,
                                },
                              }"
                            >
                              <img
                                :src="
                                  shangpins[(i - 1) * 3 + 1].tupian.length > 0
                                    ? shangpins[(i - 1) * 3 + 1].tupian[0]
                                    : $tupianmoren
                                "
                                alt=""
                                width="100"
                                height="113"
                              />
                            </router-link>
                          </figure>
                          <div class="product-details">
                            <h4 class="product-name">
                              <router-link
                                :to="{
                                  path: '/product',
                                  query: {
                                    ukey: shangpins[(i - 1) * 3 + 1].ukey,
                                  },
                                }"
                              >
                                {{ duoyuyan(shangpins[(i - 1) * 3 + 1]) }}
                              </router-link>
                            </h4>
                            <div class="product-price">
                              <span
                                v-if="
                                  shangpins[(i - 1) * 3 + 1].leixing === 1 ||
                                  shangpins[(i - 1) * 3 + 1].leixing === 3
                                "
                              >
                                {{
                                  (
                                    shangpins[(i - 1) * 3 + 1].jiage / 100
                                  ).toFixed(2) + $shezhi.huobi
                                }}
                              </span>
                              <span
                                v-if="shangpins[(i - 1) * 3 + 1].leixing === 2"
                              >
                                {{
                                  (
                                    min_jiage(shangpins[(i - 1) * 3 + 1]) / 100
                                  ).toFixed(2) + $shezhi.huobi
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="product product-widget"
                          v-if="shangpins[(i - 1) * 3 + 2]"
                        >
                          <figure class="product-media">
                            <router-link
                              :to="{
                                path: '/product',
                                query: {
                                  ukey: shangpins[(i - 1) * 3 + 2].ukey,
                                },
                              }"
                            >
                              <img
                                :src="
                                  shangpins[(i - 1) * 3 + 2].tupian.length > 0
                                    ? shangpins[(i - 1) * 3 + 2].tupian[0]
                                    : $tupianmoren
                                "
                                alt=""
                                width="100"
                                height="113"
                              />
                            </router-link>
                          </figure>
                          <div class="product-details">
                            <h4 class="product-name">
                              <router-link
                                :to="{
                                  path: '/product',
                                  query: {
                                    ukey: shangpins[(i - 1) * 3 + 2].ukey,
                                  },
                                }"
                              >
                                {{ duoyuyan(shangpins[(i - 1) * 3 + 2]) }}
                              </router-link>
                            </h4>
                            <div class="product-price">
                              <span
                                v-if="
                                  shangpins[(i - 1) * 3 + 2].leixing === 1 ||
                                  shangpins[(i - 1) * 3 + 2].leixing === 3
                                "
                              >
                                {{
                                  (
                                    shangpins[(i - 1) * 3 + 2].jiage / 100
                                  ).toFixed(2) + $shezhi.huobi
                                }}
                              </span>
                              <span
                                v-if="shangpins[(i - 1) * 3 + 2].leixing === 2"
                              >
                                {{
                                  (
                                    min_jiage(shangpins[(i - 1) * 3 + 2]) / 100
                                  ).toFixed(2) + $shezhi.huobi
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getShangPin } from "@/api/shangpin";
import { getJiHe } from "@/api/jihe";

export default {
  name: "Product",
  components: {},
  data() {
    return {
      loading: false,
      ukey: "",
      shangpin: {},
      jihe: [],
      shangpins: [],
      guige: null,
      count: 1,
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.ukey != from.query.ukey) {
        this.ukey = to.query.ukey;
        this.get_shangpin_http();
      }
    },
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    this.get_shangpin_http();
    this.get_jihe_http();
  },
  methods: {
    get_shangpin_http() {
      this.loading = true;
      getShangPin({ ukey: this.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") {
            this.shangpin = data.data;
            if (this.shangpin.leixing === 2) this.guige = this.shangpin.sku[0];
            if (this.shangpin.leixing === 3) console.log(this.shangpin.menu);
          }
        })
        .finally(() => (this.loading = false));
      getShangPin().then((data) => {
        if (data.status === "SUCCESSED") this.shangpins = data.data;
      });
    },
    get_jihe_http() {
      getJiHe({ leixingukey: this.$shezhi.shangpinjiheukey }).then((data) => {
        if (data.status === "SUCCESSED") this.jihe = data.data;
      });
    },
    min_jiage(item) {
      let min = item.sku.length > 0 ? item.sku[0].jiage : 0;
      for (let i = 0, len = item.sku.length; i < len; i += 1) {
        if (item.sku[i].jiage < min) min = item.sku[i].jiage;
      }
      return min;
    },
    format_guige(guige) {
      let src = "";
      for (let i = 0, len = guige.length; i < len; i += 1) {
        src += this.duoyuyan(guige[i].guigezhi);
        if (i < guige.length - 1) src += " / ";
      }
      return src;
    },
  },
};
</script>

<style scoped>
.guige {
  margin-bottom: 0.8rem;
  display: flex;
}

.guige-item {
  display: block;
  text-align: center;
  margin-bottom: 0.5rem;
  margin-right: 0.8rem;
  padding: 0.6rem 0.8rem;
  width: auto;
  height: auto;
  line-height: 1;
  font-size: 1.2rem;
  border: 1px solid #ccc;
  border-radius: 2px;
  color: #666;
  transition: border-color 0.35s, color 0.35s;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}

.yxl-btn-cart {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-bottom: 1rem;
  padding-left: 0;
  padding-right: 0;
  min-width: 14rem;
  border-radius: 3px;
  font-weight: 600;
}
</style>